__turbopack_context__.v({
  "heroBgMedia": "STHeroCommon-module__0sStvq__heroBgMedia",
  "heroCommon": "STHeroCommon-module__0sStvq__heroCommon",
  "heroCommonContent": "STHeroCommon-module__0sStvq__heroCommonContent",
  "heroCommonDescription": "STHeroCommon-module__0sStvq__heroCommonDescription",
  "heroOverlay": "STHeroCommon-module__0sStvq__heroOverlay",
});
